// src/googleAuth.js
import { gapi } from 'gapi-script';

export const initClient = (clientId, apiKey) => {
  return new Promise((resolve, reject) => {
    gapi.load('client:auth2', () => {
      gapi.client.init({
        apiKey: apiKey,
        clientId: clientId,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        scope: 'https://www.googleapis.com/auth/calendar.events.readonly',
      }).then(() => {
        resolve();
      }).catch((error) => {
        reject(error);
      });
    });
  });
};
